import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  claimDetails: {
    clientId: number;
    clientGroupId: number;
    memberId: string;
    claimId: number;
    dateOfService: string;
    facility: string;
    patientId: number;
    addedDate: string;
    updatedDate: string;
    status: string;
    totalChargeAmount: number;
    document: 
      {
        id: string;
        type: string;
        editable: boolean;
        order: number;
      }[];
    procedureLabel: string;
  };
  error: boolean;
  loading: boolean;
} = {
  claimDetails: {
    clientId: 0,
    clientGroupId: 0,
    memberId: "N/A",
    claimId: 0,
    dateOfService: "N/A",
    facility: "N/A",
    patientId: 0,
    addedDate: "N/A",
    updatedDate: "N/A",
    status: "N/A",
    totalChargeAmount: 0,
    document: [
      {
        id: "",
        type: "N/A",
        editable: false,
        order: 0,
      },
    ],
    procedureLabel: "N/A",
  },
  error: false,
  loading: false,
};
const fetchBBClaimDetails = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BALANCE_BILLING_CLAIM_DETAILS_SUCCESS: {
      return updateObject(state, {
        claimDetails: action.claimDetails,
        error: false,
        loading: false,
      });
    }

    case actionTypes.FETCH_BALANCE_BILLING_CLAIM_DETAILS_FAILED:
      return updateObject(state, {
        claimDetails: initialState.claimDetails,
        error: true,
        loading: false,
      });

    case actionTypes.FETCH_BALANCE_BILLING_CLAIM_DETAILS_STARTED:
      return updateObject(state, {
        claimDetails: initialState.claimDetails,
        error: false,
        loading: true,
      });

    case actionTypes.RESET_BALANCE_BILLING_CLAIM_DETAILS:
      return updateObject(state, {
        claimDetails: initialState.claimDetails,
        error: false,
        loading: false,
      });

    default:
      return state;
  }
};

export default fetchBBClaimDetails;
